<template>
	<stats-view class="h-100"></stats-view>
</template>

<script>
import StatsView from './components/StatsView.vue';

export default {
	components: {
		StatsView,
	},
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
	},
}
</script>

<style>
html, body, #app { height: 100%; margin: 0; }
html.obs ::-webkit-scrollbar { width: 10px }
html.obs ::-webkit-scrollbar-track { background: #241e32 }
html.obs ::-webkit-scrollbar-thumb { background: #eb5dff; border-radius: 5px }
html.obs ::-webkit-scrollbar-thumb:hover { background: #5df286 }
</style>
